import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    theme: { 
        dark: true,
        themes: {
            dark: {
                primary: '#ffa41d',
            }
        }
    },
}

export default new Vuetify(opts)